import { render } from "./borCor.vue?vue&type=template&id=3e9c9232"
import script from "./borCor.vue?vue&type=script&lang=js"
export * from "./borCor.vue?vue&type=script&lang=js"

import "./borCor.vue?vue&type=style&index=0&id=3e9c9232&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__